<div class="d-flex justify-content-between">
  <div class="form-group">
    <div class="dropdown dropdown-bhp">
      <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
        <input class="dropdown-toggle" [ngModel]="selectedName | translate" type="text" readonly />
        <span class="label-dropdown"></span>
        <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg"  />
      </div>
      <ul class="dropdown-menu">
        <li class="dropdown-item" (click)="onSelectChange('quickCommentsAnalysis')" value="quickCommentsAnalysis" [ngClass]="select === 'quickCommentsAnalysis' ? 'active' : ''" >{{ 'EVALUATION.QUICK_COMMENTS_ANALYSIS' | translate }}</li>
        <li class="dropdown-item" (click)="onSelectChange('overallComplianceScore')" value="overallComplianceScore" [ngClass]="select === 'overallComplianceScore' ? 'active' : ''" >{{ 'EVALUATION.OVERALL_COMPLIANCE_SCORE' | translate }}</li>
        <li class="dropdown-item" (click)="onSelectChange('individualAuditDataOverview')" value="individualAuditDataOverview" [ngClass]="select === 'individualAuditDataOverview' ? 'active' : ''" >{{ 'EVALUATION.INDIVIDUAL_AUDIT_DATA_OVERVIEW' | translate }}</li>
      </ul>
    </div>
  </div>
</div>

<kendo-excelexport [data]="gridData" [fileName]="getFileName('xlsx')" #excelexport>
  <kendo-excelexport-column field="{{i.field}}" title="{{i.title | translate}}" *ngFor="let i of fields,  let indexx = index;" class="non-action-columns" [width]="i.width">
  </kendo-excelexport-column>
</kendo-excelexport>

<ng-container *ngFor="let result of results">
<kendo-excelexport [data]="result.gridData" filename="ReportMyHygieneSOP.xlsx" #multiselectExcelExport>
  <kendo-excelexport-column field="{{i.field}}" title="{{i.title | translate}}"
      *ngFor="let i of result.fields,  let indexx = index;" class="non-action-columns" [width]="i.width">
     <ng-template kendoGridCellTemplate let-dataItem="dataItem" *ngIf="i.ngTemplate">
      {{i.ngTemplate(dataItem)}}
      </ng-template>
  </kendo-excelexport-column>
</kendo-excelexport>
</ng-container>